<div class="category-list">
  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  
  <div *ngIf="!loading && categories.length === 0" class="empty-state">
    {{ 'request_v2.category_list.no_categories' | translate }}
  </div>
  
  <div class="category-card" *ngFor="let category of categories">
    <div class="category-header">
      <div class="category-icon" [style.backgroundColor]="category.color">
        <i [class]="category.icon"></i>
      </div>
      <div class="category-title">{{ getCategoryName(category) }}</div>
      <div class="category-actions">
        <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
          <i class="icon-more-vertical"></i>
        </button>
        <mat-menu #menu="matMenu" class="category-custom-menu">
          <button mat-menu-item (click)="onEdit(category)">
            <span>{{ 'request_v2.common.edit' | translate }}</span>
          </button>
          <button mat-menu-item (click)="onDelete(category)">
            <span>{{ 'request_v2.common.delete' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="category-content">
      <div class="section subcategory-section">
        <div *ngIf="!category.subCategories || category.subCategories.length === 0" class="empty-subcategories">
          {{ 'request_v2.category_list.no_subcategories' | translate }}
        </div>
        <div class="subcategory-details-grid" *ngIf="category.subCategories && category.subCategories.length > 0">
          <!-- Header Row -->
          <div class="grid-header">{{ 'request_v2.category_list.subcategory' | translate }}</div>
          <div class="grid-header">{{ 'request_v2.category_list.department' | translate }}</div>
          <div class="grid-header">{{ 'request_v2.category_list.sla' | translate }}</div>
          <div class="grid-header">{{ 'request_v2.category_list.assignees' | translate }}</div>

          <!-- Data Rows -->
          <ng-container *ngFor="let subCategory of category.subCategories">
            <div class="grid-cell subcategory-name-cell">
              {{ getSubCategoryName(subCategory) }}
            </div>
            <div class="grid-cell department-cell">
              <div class="department-badge" 
                   *ngIf="subCategory.department" 
                   [ngStyle]="{
                     'background-color': getChipBackgroundColor(subCategory.department?.color),
                     'color': '#000000'
                   }">
                {{ subCategory.department?.name }}
              </div>
              <div class="empty-department" *ngIf="!subCategory.department">
                -
              </div>
            </div>
            <div class="grid-cell sla-cell">
              <span *ngIf="subCategory.slaInDays !== null && subCategory.slaInDays !== undefined">
                {{ subCategory.slaInDays }} {{ 'request_v2.category_list.days' | translate }}
              </span>
              <span *ngIf="subCategory.slaInDays === null || subCategory.slaInDays === undefined">
                {{ 'common.nonavailable' | translate }}
              </span>
            </div>
            <div class="grid-cell assignees-cell">
              <div class="assignees-list-horizontal" *ngIf="subCategory.department?.managers && subCategory.department.managers.length > 0">
                <div class="assignee-avatar" *ngFor="let manager of subCategory.department.managers">
                  <img *ngIf="manager.picture" [src]="manager.picture" [alt]="getManagerFullName(manager)" [title]="getManagerFullName(manager)">
                  <span *ngIf="!manager.picture" [title]="getManagerFullName(manager)">{{ getManagerInitials(manager) }}</span>
                </div>
              </div>
              <div *ngIf="!subCategory.department?.managers || subCategory.department.managers.length === 0">
                -
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div> 